<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>物业管理</el-breadcrumb-item>
      <el-breadcrumb-item>房间管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.roomName" placeholder="输入房间名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.username" placeholder="输入用户姓名"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin'" label="选择部门">
         <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handelAdd">添加</el-button>
      </el-form-item>

    </el-form>

   <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
    style="width: 100%;"  stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column  label="房间名称" >
        <template slot-scope="scope">
          <el-button size="small" @click="showDetail" type="text">{{scope.row.roomName}}</el-button>
         </template>
      </el-table-column>

      <el-table-column  prop="roomArea" label="房屋面积"  min-width="100" show-overflow-tooltip>

      </el-table-column>
      <el-table-column  prop="unitName" label="单元"  min-width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="floor" label="楼层"  min-width="100" show-overflow-tooltip>
      </el-table-column>
     <el-table-column align="center" label="操作" width="350">
        <template slot-scope="scope">
          <el-button size="mini"    @click="handleEdit(scope.row)" >编辑</el-button>
          <el-button size="mini" type="danger"   @click="deleteInfo(scope.row)" >删除</el-button>
          <el-button size="mini" type="primary">查看合同</el-button>
       <!--   <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button>
          <el-button size="mini" type="primary"   @click="handleRecharge(scope.$index, scope.row,'1')">充值</el-button>
          <el-button size="mini" type="warning"   @click="handleRecharge(scope.$index, scope.row,'2')">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="editFormVisible = false">
    	<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
           <el-select v-model="editForm.depId" placeholder="请选择部门"  size="small" @change="chageDept">
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
    		<el-form-item label="房间名称" prop="roomName">
    			<el-input size="small" v-model="editForm.roomName" auto-complete="off" placeholder="请输入房间名称"></el-input>
    		</el-form-item>
    		<el-form-item label="房间大小(㎡)" prop="roomArea">
    			<el-input size="small" v-model="editForm.roomArea" type="number" auto-complete="off" placeholder="请输入房间大小"></el-input>
    		</el-form-item>

        <el-form-item  label="选择计量点" prop="meterInfoIds">
          <el-select multiple @change="getMeterIds"  filterable v-model="meterInfoIds" placeholder="请选择计量点"  size="small" style="width: 100%;">
             <el-option
                v-for="item in meterList"
                :key="item.id"
                :label="item.meterPointName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>

        <el-form-item  label="选择单元" prop="unit">
          <el-select  filterable v-model="editForm.unitId" placeholder="请选择单元"  size="small" @change="unitChange">
             <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label="选择楼层" prop="选择楼层">
          <el-select  filterable v-model="editForm.floor" placeholder="请选择选择楼层"  size="small" >
             <el-option
                v-for="item in floolList"
                :key="item"
                :label="item+1+'层'"
                :value="item+1">
              </el-option>
            </el-select>
        </el-form-item>

    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="editFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
    	</div>
    </el-dialog>





  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import { getDepartmentTerminalInfoLis,findMeterInfoList,getDepartmentIdByMeterInfos } from '../../api/energyMG'
  import {
    findAllMeterInfoList,
    deleteRentRoom,
    addRentRoom,

    updateRoom,
    roomRecharge,
    generateWaterAndPropertyMonthlyBill,
    roomRefund,
    getUnitList,
    findRentRoomList
  } from '../../api/payMG.js'

  export default {
    data() {

      var validatePass = (rule, value, callback) => {
      	if (this.totalFee == "") {
      		let msg = this.rtitle == '充值'?'请输入充值金额':'请输入退款金额'
      		callback(new Error(msg));
      	} else {
      		if( this.rtitle == '退款'){

            let bmoney = this.reditForm.roomType == 63 ? this.money.water : this.money.wuYe

      			if( this.totalFee > bmoney){
      				return callback(new Error('退款金额不能大于当前余额'));
      			}
      		}
      		callback();
      	}
      };
      return {
        meterInfoIds:[],
        unitList:[],
        floolList:[],
        formInline: {
          depId:'',
          pageSize:10,
          currentPage:1,
          total:0,
          meterInfoName:"",
          username:"",
          phoneNumber:"",
          roomName:"",
        },
        downloadLoadin:false,
        saveLoad:false,
        crules:{
        	totalFee: [{
        		validator: validatePass,
        		trigger: 'blur'
        	}],
        },
        totalFee:"",
        users:[],
        editForm:{
          depId:"",
          roomName:"",
          roomArea:"",
          meterInfoIds:"",
          unitId:"",
          floor:""

        },

        meterList:[],

        mForm:{
          terIds:JSON.stringify([]),
          currentPage: 1,
          pageSize: 999999,
        },

        pageparm:{

        },
        rtitle:"",
        rechargeFormVisible:false,
        setLoading:false,
        tableHeight:0,
        title:"",
        loading:false,
        meterPointName:"",
        editFormVisible:false,
        dataList:[],
        deptList:[],
        user:{},
        showPage:true,
        reditForm: {
        	totalFee:"",
        	appletUserId:'',
          roomId:"",
        	mark:"",
          roomType:"63",
          payType:'2',
        },
        dForm:{
          roomName:"",
          userName:'',
          blance:"",

        },
        money:{
          water:'',
          wuYe:"",
        },

        rules: {
        	roomName: [{required: true,message: '请输入房间名称',trigger: 'blur'}],
          roomArea: [{required: true,message: '请输入房间大小',trigger: 'blur'}],
          meterInfoIds: [{required: true,message: '请选择计量点',trigger: 'change'}],

        	// roomNum:[{validator:validatePass,trigger:'change' }]

        },
      }
    },
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
    created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      if(this.user.username != 'admin'){
         this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
         this.editForm.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
         this.getMeterList()
         this.getUnitData()

      }

      this.getJzData()
      this.getData()

    },
    components: {
      Pagination,
      PremsButton
    },
    methods:{

      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})
      },
      chageDept(){
        this.getMeterList()
        this.getUnitData()
      },

      showDetail(){
      },


      getMeterIds(){
        this.editForm.meterInfoIds = this.meterInfoIds.join(',')
      },

      getUnitData(){

        let pram = {
          departmentId: this.editForm.depId,
          pageSize:999999,
          currentPage:1,
          total:0,
          unitName:"",
        }
        getUnitList(pram).then(res => {
          this.loading = false
          if(res.status == 1){
            this.unitList = res.data.data


          }else{
            this.$message.error(res.msg)
          }
        })
      },

      unitChange(id){

        let floor = this.unitList.filter( item => {
            if(item.id == id){
              return item
            }
        })[0]


        let arr = []
        for(let i = 0;i<floor.layers;i++){
          arr.push(i)
        }
        this.floolList = arr

      },

      getData(){
        this.loading = true
        findRentRoomList(this.formInline).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          }else{
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd(){
        this.editFormVisible = true
        this.title = '添加'
        this.editForm.id = ""
        this.editForm.roomName = ''
        this.editForm.roomArea = ''
        this.editForm.meterInfoIds = ''

      },

      handleEdit(row){
        this.title = '编辑'

        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.roomName = row.roomName
        this.editForm.roomArea = row.roomArea
      //  this.editForm.meterInfoIds = row.meterInfoId
        this.editForm.unitId = row.unit
        this.editForm.floor = row.floor
        this.editForm.depId = row.departmentId

        this.meterInfoIds  =  row.meterInfos.map(item => item.meterId)







      },
      search(){
        this.getData()
      },
      callFather(parm){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      deleteInfo(row){
        this.$confirm('确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
        		// 删除
        		deleteRentRoom({
        				id: row.id
        			})
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getData()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})
        			.catch(err => {
        				this.loading = false
        				this.$message.error('删除失败，请稍后再试！')
        			})
        	})
        	.catch(() => {
        		this.$message({
        			type: 'info',
        			message: '已取消删除！'
        		})
        	})
      },
      getMeterInfoList() {
      	this.loadMeter = true
      	let param = {
      		meterPointName: this.meterPointName,
      		energyType:15,
      		priceConfigId:this.curPriceId
      	}
      	findAllMeterInfoList(param).then(res => {
      		this.loadMeter = false
      		if (res.status == 1) {

      			this.MeterInfoList = res.data

      			//this.setChoisMeter(row)
      		} else {
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.loadMeter = false
      		this.$message.error('获取数据失败，请稍后再试！')
      	})

      },


      getMeterList(){
        getDepartmentIdByMeterInfos({depId:this.editForm.depId}).then(res => {
        	if(res.status == 1){
        		this.meterList = res.data

        	}else{
        		this.loading = false
        		this.$message.error(res.msg)
        	}
        })
        .catch( err =>{
        	this.loading = false
        	this.$message.error(err)
        })
      },

      submitForm(){

        this.$refs['editForm'].validate(valid => {

        	if(valid){
            if(this.title == '添加'){
              this.add()
            }else{
              this.update()
            }
          }
        })


      },

      add(){
        addRentRoom(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      },
      update(){
        updateRoom(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/property/zRoom.vue